import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { cast, getParent, types } from 'mobx-state-tree';
import { v4 as uuid } from 'uuid';
import { api } from 'src/api';
import { createAsync } from 'src/utils/asyncModel';
import { toJS } from 'mobx';
const getPropertyReportAsync = createAsync(body => {
  return async function getPropertyReport(options) {
    const resp = await api.Report.getPropertyReport(body, options);
    const _getParent = getParent(this),
      report = _getParent.report;
    report.setPropertyReportsAfterLoad(resp);
    return resp;
  };
});
const getPropertiesReportsAsync = createAsync(body => {
  return async function getPropertiesReports(options) {
    const resp = await api.Report.getPropertiesARReports(body, options);
    return resp;
  };
});
const downloadPropertyReportAsync = createAsync(body => {
  return async function downloadPropertyReport(options) {
    const resp = await api.Report.downloadPropertyReport(body, options);
    return resp;
  };
});
const downloadCombinedPropertiesReportAsync = createAsync(body => {
  return async function downloadCombinedPropertiesReport(options) {
    const resp = await api.Report.downloadCombinedPropertiesReport(body, options);
    return resp;
  };
});
const getReimbursementAsync = createAsync(body => {
  return async function getReimbursement(options) {
    const resp = await api.Report.getReimbursement(body, options);
    return resp;
  };
});
const sendReportAsync = createAsync(body => {
  return async function sendReport(options) {
    const resp = await api.Report.sendReport(body, options);
    return resp;
  };
});
const getReimbursementReportAsync = createAsync(body => {
  return async function getReimbursementReport(options) {
    const resp = await api.Report.getReimbursementReport(body, options);
    return resp;
  };
});
const getReimbursementReportV2Async = createAsync(body => {
  return async function getReimbursementReportV2(options) {
    const resp = await api.Report.getReimbursementReportV2(body, options);
    return resp;
  };
});
const getReimbursementReportSlimAsync = createAsync(body => {
  return async function getReimbursementReport(options) {
    const resp = await api.Report.getReimbursementSlimReport(body, options);
    return resp;
  };
});
const getReimbursementReceiptAsync = createAsync(body => {
  return async function getReimbursementReceipt(options) {
    const resp = await api.Report.getReimbursementReceipt(body, options);
    return resp;
  };
});
const getReimbursementReceiptPeriodsAsync = createAsync(body => {
  return async function getReimbursementReceiptPeriods(options) {
    const resp = await api.Report.getReimbursementReceiptPeriods(body, options);
    return resp;
  };
});
const downloadReimbursementReceiptAsync = createAsync(body => {
  return async function downloadReimbursementReceipt(options) {
    const resp = await api.Report.downloadReimbursementReceipt(body, options);
    return resp;
  };
});
const downloadChargeExportAsync = createAsync(body => {
  return async function downloadChargeExport(options) {
    const resp = await api.Report.downloadChargeExport(body, options);
    return resp;
  };
});
const Report = types.model('Report', {
  currentPeriod: types.maybeNull(types.string),
  dayMonthPeriod: types.maybeNull(types.string),
  emailAddress: types.maybeNull(types.string),
  id: types.string,
  moreThreeMonthPeriod: types.maybeNull(types.string),
  oneMonthTwoMonthPeriod: types.maybeNull(types.string),
  phone: types.maybeNull(types.string),
  residentFullName: types.string,
  total: types.maybeNull(types.string),
  twoMonthThreeMonthPeriod: types.maybeNull(types.string),
  unitName: types.maybeNull(types.string)
});
const getDecimal = value => value ? parseFloat(value).toFixed(2) : null;
const ReportStore = types.model('ReportStore', {
  downloadPropertyReportAsync,
  downloadCombinedPropertiesReportAsync,
  getPropertyReportAsync,
  getPropertiesReportsAsync,
  getReimbursementAsync,
  getReimbursementReportAsync,
  getReimbursementReportV2Async,
  getReimbursementReportSlimAsync,
  getReimbursementReceiptAsync,
  getReimbursementReceiptPeriodsAsync,
  downloadReimbursementReceiptAsync,
  downloadChargeExportAsync,
  propertyReportsValue: types.optional(types.array(Report), []),
  sendReportAsync
}).actions(store => {
  return {
    setPropertyReportsAfterLoad(data) {
      try {
        const reports = data.response.map(item => _objectSpread(_objectSpread({}, item), {}, {
          currentPeriod: getDecimal(item.currentPeriod),
          dayMonthPeriod: getDecimal(item.dayMonthPeriod),
          moreThreeMonthPeriod: getDecimal(item.moreThreeMonthPeriod),
          oneMonthTwoMonthPeriod: getDecimal(item.oneMonthTwoMonthPeriod),
          total: getDecimal(item.total),
          twoMonthThreeMonthPeriod: getDecimal(item.twoMonthThreeMonthPeriod),
          id: uuid()
        }));
        store.propertyReportsValue = cast([...reports]);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    }
  };
}).views(store => ({
  get propertyReports() {
    return toJS(store.propertyReportsValue);
  }
}));
export const report = types.optional(ReportStore, {});